import { Add, Clear, Search } from "@mui/icons-material";
import { Fab, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { Box, BoxProps } from "@mui/system";

export const SearchToolbar = ({
  text,
  setText,
  onAddClick,
  placeholder,
  boxProps,
  textFieldProps,
}: {
  text: string;
  setText: React.Dispatch<React.SetStateAction<string>>;
  onAddClick?: () => void;
  placeholder?: string;
  boxProps?: BoxProps;
  textFieldProps?: TextFieldProps;
}) => {
  return (
    <Box {...boxProps}>
      <TextField
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            // Handle Esc key press here
            setText("");
          }
        }}
        placeholder={placeholder || "Find.."}
        sx={{ paddingRight: 2 }}
        size="small"
        variant="outlined"
        onChange={(e) => setText(e.target.value)}
        value={text}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              style={{ display: text ? "flex" : "none" }}
              onClick={() => setText("")}
            >
              <Clear />
            </InputAdornment>
          ),
        }}
        {...textFieldProps}
      />
      {onAddClick && (
        <Fab
          aria-label="logout"
          color="primary"
          // disabled={processing}
          onClick={onAddClick}
          size="small"
        >
          <Add />
        </Fab>
      )}
    </Box>
  );
};
